var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICalorieWeight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 5.18848C7.67724 5.18848 3.77765 6.97823 0.996094 9.85446L6.1129 14.9713C7.58708 13.4024 9.67437 12.4151 11.9961 12.4151C14.3178 12.4151 16.4051 13.4024 17.8793 14.9713L22.9961 9.85446C20.21 6.97823 16.3104 5.18848 11.9961 5.18848Z",
    fill: "#4685EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6151 15.9409L12.1327 7.59622C12.1237 7.4204 11.8667 7.4204 11.8532 7.59622L11.3708 15.9409C10.8975 16.1708 10.5684 16.6532 10.5684 17.2122C10.5684 17.9966 11.204 18.6323 11.9884 18.6323C12.7729 18.6323 13.4085 17.9966 13.4085 17.2122C13.4085 16.6487 13.0794 16.1708 12.6061 15.9409H12.6151Z",
    fill: "#10141A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICalorieWeight);
export default __webpack_public_path__ + "static/media/i_calorie_weight.989f07e9adf4d57cf58763652605dc00.svg";
export { ForwardRef as ReactComponent };